import type { IconName } from '@lemonade-hq/uniclient-theme';
import type { UniclientAction, UniclientComponent } from '..';
import type { GridResponsiveColumns } from '../utils';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export interface BaseIllustratedCardProps extends UniclientBaseComponentProps {
  readonly title: string;
  readonly image: string;
  readonly badge?: string;
  readonly showDiamond?: boolean;
  readonly buttonVariant?: 'primary' | 'secondary';
  readonly buttonIcon?: IconName;
  readonly rightAlignedIllustration?: boolean;
  readonly leftAligned?: boolean;
}
export interface SingleIllustratedCardProps extends BaseIllustratedCardProps {
  readonly content: UniclientComponent<string, string> | string;
  readonly action?: UniclientAction;
  readonly secondaryAction?: UniclientAction;
}

export interface IllustratedCardsProps<TAttribute extends string> extends UniclientBaseComponentProps {
  readonly columns?: GridResponsiveColumns;
  readonly disabled?: boolean;
  readonly attribute: TAttribute;
  readonly twoItemsPerRow?: boolean;
  readonly centerAlignItems?: boolean;
  readonly cards: SingleIllustratedCardProps[];
}

export type WizardIllustratedCardsProps<TAttribute extends string> = IllustratedCardsProps<TAttribute> &
  UniclientWizardComponentBase<'illustrated_cards'>;

export function illustratedCards<TAttribute extends string>(
  props: IllustratedCardsProps<TAttribute>,
): WizardIllustratedCardsProps<TAttribute> {
  return {
    ...props,
    type: 'illustrated_cards',
  };
}
